// extracted by mini-css-extract-plugin
export var bodySections = "_9u-8";
export var gray = "_9u-7";
export var green = "_9u-4";
export var iconContainer = "_9u-9";
export var iconWidgetContainer = "_9u-1";
export var phoneIcon = "_9u-2";
export var red = "_9u-5";
export var statusDot = "_9u-3";
export var widgetContainer = "_9u-0";
export var yellow = "_9u-6";